import React from 'react';
import PropTypes from 'prop-types';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import AudioTrack from './AudioTrack';
import { connect } from 'store/modules/base/redux';
import { MEDIA_TYPE } from 'store/modules/base/media';

/**
 * A container for the remote tracks audio elements.
 *
 * @param {Props} props - The props of the component.
 * @returns {Array<ReactElement>}
 */
function AudioTracksContainer(props) {
  const { _tracks } = props;
  const remoteAudioTracks = _tracks.filter(
    (t) => !t.local && t.mediaType === MEDIA_TYPE.AUDIO
  );

  return (
    <div>
      {remoteAudioTracks.map((t, index) => {
        const { jitsiTrack, participantId } = t;
        const audioTrackId = jitsiTrack && jitsiTrack.getId();
        const id = `remoteAudio_${audioTrackId || ''}${index}`;

        return (
          <AudioTrack
            audioTrack={t}
            id={id}
            key={id}
            participantId={participantId}
          />
        );
      })}
    </div>
  );
}

/**
 * Maps (parts of) the Redux state to the associated {@code AudioTracksContainer}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  // NOTE: The disadvantage of this approach is that the component will re-render on any track change.
  // One way to solve the problem would be to pass only the participant ID to the AudioTrack component and
  // find the corresponding track inside the AudioTrack's mapStateToProps. But currently this will be very
  // inefficient because features/base/tracks is an array and in order to find a track by participant ID
  // we need to go through the array. Introducing a map participantID -> track could be beneficial in this case.
  return {
    _tracks: state['features/base/tracks']
  };
}

export default React.memo(
  connect(_mapStateToProps)(withBoundary(AudioTracksContainer))
);
AudioTracksContainer.propTypes = {
  _tracks: PropTypes.array
};
